var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-input-number',{staticClass:"ainput-number",attrs:{"value":_vm.value,"precision":_vm.precision,"controls":_vm.controls,"min":_vm.min,"max":_vm.max,"placeholder":_vm.placeholder},on:{"change":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }